import React from 'react';
import { StringConstants, CharConstants } from "../WorkkardDetail/constants";
import Icon from "../../icons";
import _ from 'lodash';

const MODULE_CONFIG = {
    [StringConstants.workkard]: {
        href:       (moduleId) => `/getclmdetail?cId=${moduleId}`,
        badgeClass: 'wkSymbol',
        char:       CharConstants.Workkard,
    },
    [StringConstants.activity]: {
        href:       (moduleId) => `/gad?actId=${moduleId}`,
        badgeClass: 'actSymbol',
        char:       CharConstants.Activity,
    },
};

export const renderModuleType = (data, showLink = false) => {
    const config = MODULE_CONFIG[data.module_type];
    const ModuleLink = ({ href, badgeClass, char, showLink, label }) => (
        <a href={showLink ? href : '#'} className={showLink ? 'rowFlex alignMiddle' : ''}>
            <span className={`badges ${badgeClass} mr`}>{char}</span>
            {showLink && label}
        </a>
    );

    if (config) {
        return (
            <ModuleLink
                href={config.href(data.module_id)}
                badgeClass={config.badgeClass}
                char={config.char}
                showLink={showLink}
                label={data.TodoLink} // todo: Ensure this property exists in the data object
            />
        );
    }

    // If diary is personal 
    if (!data?.module_type) {
        return (
            <>
                <Icon name="personal" className="icon shift__top__1 mr" />
                {showLink && "Personal Diary"}
            </>
        );
    }

    return null;
};

export const formatTimestamp = (
  unixTimestamp,
  timeZone = "UTC",
  format = "datetime",
  is12Hour = true
) => {
    if (!unixTimestamp) return undefined;

    const options = {timeZone};

    if (format === "date" || format === "datetime") {
        options.year = "numeric";
        options.month = "numeric";
        options.day = "numeric";
    }

    if (format === "monthDay") {
        options.month = "short";
        options.day = "2-digit";
    }

    if (format === "time" || format === "datetime") {
        options.hour = "numeric";
        options.minute = "2-digit";
        options.hour12 = is12Hour;
    }

    return new Intl.DateTimeFormat("en-US", options)?.format(
        new Date(unixTimestamp * 1000)
    );
};

export const PriorityFlag = ({ priority, isCompleted, status }) => {
    if (priority != 'high' || isCompleted || status !== "OPEN") return null;
    return (
        <span className="priority flagHigh animated superFaster delay-5 mr">
            <Icon name="flag" className="icon ml" />
        </span>
    );
};

// Groups diary items based on due_date.
export function groupDiariesByDate(list = []) {
    const groupsData = new Map();

    list.forEach((item) => {
        const dueOn = item?.due_date;
        const timeZone = item?.due_date_tz || 'UTC';

        if (!dueOn) return;

        const date = new Date(dueOn * 1000); // seconds -> ms
        if (isNaN(date.getTime())) return;

        const dayKey = date.toLocaleDateString('en-US', { timeZone });

        if (!groupsData.has(dayKey)) {
            groupsData.set(dayKey, {
                created_date: date.toLocaleDateString('en-US', {
                    timeZone,
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                }),
                due_on: dueOn,
                data: [],
            });
        }

        groupsData.get(dayKey).data.push(item);
    });

    // latest first as per due_on
    return Array.from(groupsData.values()).sort((a, b) => b.due_on - a.due_on).map(({ due_on, ...rest }) => rest);
}

export const getUniqueTagsWithSystemFlag = (tags = [], systemTags = []) => {
    const merged = _.union(tags, systemTags);
    return _.map(merged, (tag) => ({
        tag,
        isSystemTag: _.includes(systemTags, tag),
    }));
};